export const SavingData = [
    // {
    //   id: 1,
    //   year: 2016,
    //   save: 600000,
    // },
    // {
    //   id: 2,
    //   year: 2017,
    //   save: 400000,
    // },
    // {
    //   id: 3,
    //   year: 2018,
    //   save: 700000,
    // },
    // {
    //   id: 4,
    //   year: 2019,
    //   save: 800000,
    // },
    // {
    //   id: 5,
    //   year: 2020,
    //   save: 900000,
    // },
    // {
    //   id: 3,
    //   year: 2021,
    //   save: 100000,
    // },
    // {
    //   id: 4,
    //   year: 2022,
    //   save: 200000,
    // },
    // {
    //   id: 4,
    //   year: 2023,
    //   save: 600000,
    // },
];